import { ApiService } from '@1bill-app/services/api/api.service';
import { PopoverSimpleComponent } from '@1bill-app/components/popover/popover-simple/popover-simple.component';
import { BetterDealQuery } from '@1bill-app/services/better-deal/better-deal.query';
import { BetterDealService } from '@1bill-app/services/better-deal/better-deal.service';
import {
  BetterDealProduct,
  CncBusinessRule,
  CreateCustomerAndSalePayload,
  States,
} from '@1bill-app/services/better-deal/better-deal.type';
import { SettingsQuery } from '@1bill-app/services/settings/settings.query';
import { SettingsService } from '@1bill-app/services/settings/settings.service';
import { Settings } from '@1bill-app/services/settings/settings.store';
import {
  CustomValidationService,
  MAX_DATE,
  MAX_DOB,
  MIN_DATE,
  MIN_DOB,
  safariDateToStandardDate,
  standardDateToSafariDate,
  validateDOB,
} from '@1bill-app/services/validation/custom-validation.service';
import { PhoneValidator } from '@1bill-app/services/validation/phone.validator';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  AlertController,
  LoadingController,
  NavController,
  Platform,
  PopoverController,
  ToastController,
} from '@ionic/angular';
import { NGXLogger } from 'ngx-logger';
import { map, catchError } from 'rxjs/operators';
import { SubSink } from 'subsink';
import { ROUTE_BILLS_PAGE, ROUTE_BILL_DETAILS } from '@1bill-app/constants';
import { formatDateStandard } from '@1bill-app/helpers/date.helpers';
import { HomeService } from '@1bill-app/services/home/home.service';

@Component({
  selector: 'app-get-better-deals-signup',
  templateUrl: './get-better-deals-signup.page.html',
  styleUrls: ['./get-better-deals-signup.page.scss'],  
})
export class GetBetterDealsSignupPage implements OnInit {
 
  concessionTypes$ = this.betterDealQuery.concessionTypes$;
  titleTypes$ = this.betterDealQuery.titleTypes$;
  lifeSupportEquipmentTypes$ = this.betterDealQuery.lifeSupportEquipmentTypes$;
  streetTypes$ = this.betterDealQuery.streetTypes$.pipe(map((res) => res));
  states: string[] = States;
  
  //Store
  bill = this.betterDealQuery.getValue().bill;
  isSolar = this.betterDealQuery.getValue().isSolar;
  isLifeSupport = this.betterDealQuery.getValue().isLifeSupport;
  isResidential = this.betterDealQuery.getValue().isResidential;
  isConnection = this.betterDealQuery.getValue().isConnection;
  postcode = this.betterDealQuery.getValue().postcode;
  suburb = this.betterDealQuery.getValue().suburb;
  state = this.betterDealQuery.getValue().state;
  fuelType = this.betterDealQuery.getValue().fuelType;
  nmi = this.betterDealQuery.getValue().nmi;
  mirn = this.betterDealQuery.getValue().mirn;
  checksum = this.betterDealQuery.getValue().checksum;
  electricityDistributorId = this.betterDealQuery.getValue().electricityDistributorId;
  gasDistributorId = this.betterDealQuery.getValue().gasDistributorId;
  activeMeters = this.betterDealQuery.getValue().activeMeters;
  productChosen = this.betterDealQuery.getValue().product;
  fullAddress = this.betterDealQuery.getFullAddressText();
  firstName = this.betterDealQuery.getValue().firstName;
  email = this.betterDealQuery.getValue().email;

  //Forms
  betterDealForm: FormGroup;
  userDetailsForm: FormGroup;
  concessionCardForm: FormGroup;
  secondaryAccountForm: FormGroup;
  customAddress: FormGroup;  
  isSafariDesktop: boolean;  
  minDob = MIN_DOB;
  maxDob = MAX_DOB;
  minDate = MIN_DATE;
  maxDate = MAX_DATE;
  datePlaceholder = 'dd/mm/yyyy';
  secondaryAddress: string;  

  public loading: any;
  userDetails: Settings;
  customerId: string;
  productId: number;
  product: BetterDealProduct;

  subs = new SubSink();

  //business rules
  businessRules: CncBusinessRule[];
  concessionRule?: CncBusinessRule;
  electricityBillingCycleRule?: CncBusinessRule;
  emailBillingRule?: CncBusinessRule;
  secondaryAccountRule?: CncBusinessRule;
  actualReadRule?: CncBusinessRule;
  powerOfChoiceRule?: CncBusinessRule;
  clearAccessMeterRule?: CncBusinessRule;
  hasPowerCurrentlyRule?: CncBusinessRule;
  altToElectricityRule?: CncBusinessRule;
  electronicCertificateRule?: CncBusinessRule;
  medicalConcessionRule: CncBusinessRule;
  propertyVacantInRule: boolean;
  siteHazardNotesInRule: boolean;
  inspectionTimeframeInRule: boolean;
  retailSubscriptionExclude: boolean;

  //flags
  hasPowerCurrently: boolean;
  altToElectricity: boolean;
  electronicCertificate: boolean;
  propertyVacant: boolean;
  authorisedPerson: boolean;
  heatCoolConcession: boolean;
  concessionAccept: boolean;
  carbonNeutralOptIn: boolean;
  actualRead: boolean; // string
  powerOfChoice: boolean;
  marketingConsent: boolean;
  clearAccessElec: boolean;
  clearAccessGas: boolean;
  addSolar: boolean;
  concession: boolean;
  creditCheckConsent: boolean;

  //inputs
  complianceNumber: string;
  siteHazardNotes: string;
  billCycle: 'Monthly' | 'Quarterly' = 'Monthly';
  billFormat: 'email' | 'post' = 'email';
  billPostTo: 'connection_address' | 'different_address' = 'connection_address';
  carbonNeutralOptInValue: string;
  membershipNo: string;
  productIdStartWithArray;
  inspectionTimeframe: string;
  specialInstruction: string;
  lifeSupportDeviceId: string;
  lifeSupportFuel: 'Electricity' | 'Gas' | 'Dual';

  //CSS Error
  hasPowerCurrentlyError: boolean;
  altToElectricityError: boolean;
  electronicCertificateError: boolean;
  propertyVacantError: boolean;
  siteHazardNotesError: boolean;
  inspectionTimeframeError: boolean;
  addSolarError: boolean;
  lifeSupportFuelError: boolean;
  lifeSupportDeviceIdError: boolean;
  powerOfChoiceError: boolean;
  clearAccessElecError: boolean;
  clearAccessGasError: boolean;
  actualReadError: boolean;
  concessionError: boolean;
  heatCoolConcessionError: boolean;
  carbonNeutralOptInError: boolean;
  authorisedPersonError: boolean;
  billCycleError: boolean;
  marketingConsentError: boolean;
  billFormatError: boolean;
  billPostToError: boolean;

  //product terms and conditions
  conditions: {
    conditionId: number, //this is TC conditionId
    accepted: boolean, //boolean // TC accepted
  }[] = [];
  termsAndConditionText: string[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private navCtrl: NavController,
    private homeService: HomeService,
    private popoverController: PopoverController,
    private loadingController: LoadingController,
    private alertCtrl: AlertController,
    private logger: NGXLogger,
    public settingsQuery: SettingsQuery,
    private _cusValidation: CustomValidationService,
    private settingsService: SettingsService,
    public platform: Platform,
    private api: ApiService,
    private betterDealQuery: BetterDealQuery,
    private betterDealService: BetterDealService,
    private toastController: ToastController,
  ) {
    this.isSafariDesktop = this._cusValidation.isSafariDesktop();
    this.initForm();
  }

  ngOnInit() {
    if (this.productChosen != null) {
      this.product = this.productChosen;
      this.productId = this.productChosen.productId;

      this.subs.sink = this.betterDealService.getLifeSupportEquipmentTypes().subscribe();
      this.subs.sink = this.betterDealService.getConcessionTypes().subscribe();
      this.subs.sink = this.betterDealService.getTitleTypes().subscribe();     
      
      this.fetchData();
      this.getBusinessRules();
      this.settingsQuery.select().subscribe({
        next: (settingsData) => {          
          this.userDetails = settingsData;
          let initialFormValues = {
            lastName: this.userDetails.lastName,
            //firstName: this.userDetails.firstName,
            //email: this.userDetails.email,
            firstName: this.firstName,
            email: this.email,
            // oneBillEmail: this.userDetails.billEmail,
            mobileNumber: this.userDetails.mobileNumber,
            dateOfBirth: this.isSafariDesktop
              ? standardDateToSafariDate(this.userDetails.dateOfBirth)
              : this.userDetails.dateOfBirth,            
            title: '',
          };
          this.userDetailsForm.setValue(initialFormValues);
          this.userDetailsForm.markAllAsTouched();
        },
        error: (err) => {
          this.logger.error('unable to retrieve user setting from data store', err);
        },
      });    
    } else {
      this.logger.error('cant find product..');
      this.errorAlert();      
    }
  }

  async fetchData() {
    const loading = await this.loadingController.create({
      message: 'Loading contact data...',
    });
    loading.present();
    this.subs.sink = this.settingsService.fetch().subscribe({
      next: (r) => {
        loading.dismiss();
      },
      error: (e) => {
        this.logger.error('unable to fetch user settings data', e);
        loading.dismiss();
      },
    });
  }

  async getBusinessRules() {
    this.subs.sink = this.betterDealService
      .getBusinessRules(this.productId)
      .subscribe((res) => {
        this.businessRules = res;
        this.concessionRule = this.businessRules.find((x) => x.name == 'concession');
        this.electricityBillingCycleRule = this.businessRules.find(
          (x) => x.name == 'electricityBillingCycle',
        );
        this.emailBillingRule = this.businessRules.find((x) => x.name == 'emailBilling');
        this.secondaryAccountRule = this.businessRules.find(
          (x) => x.name == 'secondaryAccount',
        );
        this.actualReadRule = this.businessRules.find((x) => x.name == 'actualRead');
        this.powerOfChoiceRule = this.businessRules.find((x) => x.name == 'powerOfChoice');
        this.clearAccessMeterRule = this.businessRules.find(
          (x) => x.name == 'clearAccessMeter',
        );
        this.hasPowerCurrentlyRule = this.businessRules.find(
          (x) => x.name == 'hasPowerCurrently',
        );
        this.propertyVacantInRule =
          this.hasPowerCurrentlyRule?.false?.fields.includes('propertyVacant');
        this.siteHazardNotesInRule =
          this.hasPowerCurrentlyRule?.false?.fields.includes('siteHazardNotes');        
        this.inspectionTimeframeInRule =
          this.hasPowerCurrentlyRule?.false?.fields.includes('inspectionTimeframe');
        this.altToElectricityRule = this.businessRules.find(
          (x) => x.name == 'altToElectricity',
        );
        this.electronicCertificateRule = this.businessRules.find(
          (x) => x.name == 'electronicCertificate',
        );
        this.medicalConcessionRule = this.businessRules.find(
          (x) => x.name == 'medicalConcession',
        );
      });

    //business rules some weird stuff....
    this.productIdStartWithArray = ['4322', '4323', '4324'].some((x) =>
      this.productId.toString().startsWith(x),
    );
    this.retailSubscriptionExclude = [
      'Momentum Energy',
      'Simply Energy',
      'AGL',
      'Power Direct',
      'Red Energy',
      'Lumo Energy',
    ].includes(this.product.retailerName);
    
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  initForm() {
    this.userDetailsForm = new FormGroup({
      title: new FormControl('', [Validators.required]),
      firstName: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.email, Validators.required]),
      mobileNumber: new FormControl('', [
        Validators.required,
        PhoneValidator.validCountryPhone('AU'),
      ]),
      dateOfBirth: new FormControl('', [Validators.required, validateDOB(this.platform)]),
    });

    this.concessionCardForm = new FormGroup({
      concessionCardType: new FormControl('', [Validators.required]),
      concessionCardNumber: new FormControl('', [Validators.required]),
      concessionStartDate: new FormControl('', [Validators.required]),
      concessionCardExpiry: new FormControl('', [Validators.required]),
    });

    this.secondaryAccountForm = new FormGroup({
      secondarySalutation: new FormControl('', [Validators.required]),
      secondaryFirstName: new FormControl('', [Validators.required]),
      secondaryLastName: new FormControl('', [Validators.required]),
      secondaryDateOfBirth: new FormControl('', [
        Validators.required,
        validateDOB(this.platform),
      ]),
      secondaryEmail: new FormControl('', [Validators.email, Validators.required]),
      secondaryPhoneNumber: new FormControl('', [PhoneValidator.validCountryPhone('AU')]),
    });

    this.customAddress = new FormGroup({
      subpremise: new FormControl(''),
      streetNo: new FormControl('', [Validators.required]),
      streetName: new FormControl('', Validators.required),
      streetType: new FormControl(''),
      suburb: new FormControl('', Validators.required),
      state: new FormControl('', Validators.required),
      postcode: new FormControl('', Validators.required),
    });
  }

  async onSubmit() {
    //Validations..
    const valid = await this.validateForm();
    if (valid) {
      //get terms and conditions from productDetails
      const loading = await this.loadingController.create({
        message: 'Loading terms and conditions...',
      });
      await loading.present();
      try {
        await this.betterDealService
          .getProductDetails(this.productId)
          .toPromise()
          .then((res) => {            
            res.conditions.forEach((condition) => {
              this.conditions.push({
              conditionId: condition.id,
              accepted: true
              })
              this.termsAndConditionText.push(condition.description);
          });

            loading.dismiss();
          });
      } catch (err) {
        this.logger.error('unable to get product tc', err);
        loading.dismiss();
      }

      const popover = await this.popoverController.create({
        component: PopoverSimpleComponent,
        cssClass: 'better-deal-tc-popover',
        mode: 'ios',
        componentProps: {
          popoverTitle: 'Terms and Conditions', //this.product.retailerName,
          descriptionArray: this.termsAndConditionText,
          buttonText: 'Accept',
          hasBackButton: true,
        },
      });
      await popover.present();

      popover.onWillDismiss().then(async (dismissResult) => {
        if (dismissResult.role === 'confirm') {
          //Create customer and sales
          await this.createCustomerAndSale();
        }
      });
    } else {
      this.presentToast('warning', 'Please check your details.');
      return;
    }
  }

  async createCustomerAndSale() {

    //Format dates for Safari
    let dobFormat = this.userDetailsForm.get('dateOfBirth').value.split('T')[0];
    if (this.isSafariDesktop) {
      dobFormat = safariDateToStandardDate(dobFormat);
    }
    let dobSecondaryFormat = '';
    if(this.authorisedPerson){
      dobSecondaryFormat =  this.secondaryAccountForm.get('secondaryDateOfBirth').value.split('T')[0];
      if (this.isSafariDesktop) {
        dobSecondaryFormat = safariDateToStandardDate(dobSecondaryFormat);
      }
    }
    let concessionStartDateFormat = '';
    let concessionCardExpiryFormat = '';
    if(this.concession){      
      concessionStartDateFormat = (this.concessionCardForm.get('concessionStartDate').value).split('T')[0];
      concessionCardExpiryFormat = (this.concessionCardForm.get('concessionCardExpiry').value).split('T')[0];
      if (this.isSafariDesktop) {        
        concessionStartDateFormat = safariDateToStandardDate(concessionStartDateFormat);
        concessionCardExpiryFormat = safariDateToStandardDate(concessionCardExpiryFormat);
      }
    }

    //Special Instructions
    if( this.specialInstruction && this.specialInstruction != ''){
      if(this.siteHazardNotes && this.siteHazardNotes != ''){
        this.siteHazardNotes = this.siteHazardNotes + this.specialInstruction;
      }
      else{
        this.siteHazardNotes = 'siteHazardNotes:' + this.specialInstruction;
      }
    }


    let payload: CreateCustomerAndSalePayload = {
      source: '1bill', // 1bill
      //ipAddress: string,
      salutation: this.userDetailsForm.get('title').value,
      firstName: this.userDetailsForm.get('firstName').value,
      lastName: this.userDetailsForm.get('lastName').value,
      email: this.userDetailsForm.get('email').value,
      dateOfBirth: dobFormat, //YYYY-MM-DD
      phoneNumber: this.userDetailsForm.get('mobileNumber').value,
      driversLicence: this.product.retailerName != 'Origin' ? this.userDetails.idDriverLicence?.id : '', //LEGAL ISSUE. need to be empty for Origin
      licenceExpiry: this.product.retailerName != 'Origin' ? this.userDetails.idDriverLicence?.expiry : '', //YYYY-MM-DD. LEGAL ISSUE. need to be empty for Origin
      licenceState: this.product.retailerName != 'Origin' ? this.userDetails.idDriverLicence?.state : '', // VIC, QLD, NSW, TAS, SA, WA and NT.
      //mediCareCardNumber: string,
      //mediCareCardColor: string, //Green, Blue or Yellow,
      //passportNumber: string,
      //passportCountry: string,
      //identityExpiryDate: string, // for “Medi Care” “Green” the format of “YYYYMM” is required.
      lifeSupport: this.isLifeSupport,
      lifeSupportDeviceId: this.lifeSupportDeviceId,
      lifeSupportFuel: this.lifeSupportFuel,
      solar: this.isSolar,
      isConnection: this.isConnection, //Is Connection, indicates if this is a Move In deal.
      subpremise: this.betterDealQuery.getValue().subpremise,
      streetNo: this.betterDealQuery.getValue().streetNo,
      streetName: this.betterDealQuery.getValue().streetName,
      streetType: this.betterDealQuery.getValue().streetType,
      city: this.betterDealQuery.getValue().suburb,
      state: this.betterDealQuery.getValue().state,
      postcode: +this.betterDealQuery.getValue().postcode,
      accountType: this.betterDealQuery.getValue().accountType, // Residential or SME
      salesType: 'Better Deal', //Better Deal or Move In
      energy: this.product.fuelType == 'Electricity', // Whether the customer needs energy..
      gas: this.product.fuelType == 'Gas', //Whether the customer needs gas
      internet: this.product.fuelType == 'Internet', // Whether the customer needs internet
      fuelType: this.fuelType,
      secondarySalutation: this.secondaryAccountForm.get('secondarySalutation').value,
      secondaryFirstName: this.secondaryAccountForm.get('secondaryFirstName').value,
      secondaryLastName: this.secondaryAccountForm.get('secondaryLastName').value,
      secondaryDateOfBirth: dobSecondaryFormat,
      secondaryEmail: this.secondaryAccountForm.get('secondaryEmail').value,
      secondaryPhone: this.secondaryAccountForm.get('secondaryPhoneNumber').value,
      nmi: this.nmi, //electricity
      checksum: this.checksum,
      mirn: this.mirn, //gas
      electricityDistributorId : this.electricityDistributorId,
      gasDistributorId : this.gasDistributorId,
      activeMeters : this.activeMeters,
      productId: this.productId, //Product Id as returned in the Get Products
      isBillingSame: this.billFormat == 'post' ? this.billPostTo == 'connection_address' : true, //this.isBillingSame, //Is billing address same as supply address
      emailBilling: this.billFormat == 'email', 
      electricityBillingCycle: this.billCycle,
      visualInspection: this.hasPowerCurrently == false,
      concession: this.concession, 
      concessionCardNumber: this.concessionCardForm.get('concessionCardNumber').value,
      concessionStartDate: concessionStartDateFormat,
      concessionCardExpiry: concessionCardExpiryFormat,
      concessionCardType: this.concessionCardForm.get('concessionCardType').value,
      //concessionCardIssuer: string
      heatCoolConcession: this.heatCoolConcession,
      concessionTCAccepted: this.concessionAccept,
      hasPowerCurrently: this.hasPowerCurrently,
      marketingConsent: this.marketingConsent,
      altToElectricity: this.altToElectricity,
      membershipNo: this.membershipNo,
      //userIPAddress: string,
      customerId: this.customerId,
      conditions: this.conditions,
      billUnitNumber: this.customAddress.get('subpremise').value, //Billing Address Unit Number when isBillingSame is set to false.. same for below..
      billStreetNumber: this.customAddress.get('streetNo').value,
      billStreetName: this.customAddress.get('streetName').value,
      billSuburb: this.customAddress.get('suburb').value,
      //billPobox?: this.customAddress.get('subpremise').value,
      billStreetType: this.customAddress.get('streetType').value,
      billState: this.customAddress.get('state').value,
      billPostcode: this.customAddress.get('postcode').value,

      retailer: this.product.retailerName,
      actualRead: this.actualRead,
      clearAccessElec: this.clearAccessElec,
      clearAccessGas: this.clearAccessGas,
      creditCheckConsent: this.creditCheckConsent,
      carbonNeutralOptIn: this.carbonNeutralOptIn,
      carbonNeutralOptInValue: this.carbonNeutralOptInValue,
      siteHazardNotes: this.siteHazardNotes,
      inspectionTimeFrame: this.inspectionTimeframe,
      powerOfChoice: this.powerOfChoice,
      propertyVacant: this.propertyVacant,
      complianceNumber: this.complianceNumber
    };
  
    const loading = await this.loadingController.create({
      message: 'Processing...',
    });
    await loading.present();   

    this.betterDealService.createCustomerAndSale(payload).pipe(
      map((res) => {
        if (res.customerId && res.saleId) {
          //customer&sale created
          //Trigger callback
          this.customerId = res.customerId;            
          return this.switchProcessCallBack(res.customerId, res.saleId);;
        }
        return res;                
      }),      
      catchError((error) => { 
        this.logger.error('unable to create customer and sale', error);
        loading.dismiss();              
        this.errorAlert();         
        throw error;
      })
    ).subscribe( () => {
      loading.dismiss();
    },    
    );
  }

  async switchProcessCallBack(customerId: string, saleId: string){    

    let switchPayload = {
      customerId : customerId, // customer id
      type: this.product.fuelType, // product type
      cncRefId: saleId, // Switch id to track switch progress
      billTypeId: this.bill.accountBillTypeId, // billTypeId of the bill (not bill payment id)
      callbackStatus: 'success', // to cater for inconsistencies
      retailerName: this.product.retailerName, // name of the retailer selected by the customer
      retailerLogo: this.product.retailerLogo, // retailer’s logo url
      planName: this.product.planName, // name of the retailer plan selected by the customer
      address: this.fullAddress, // the supply address of the customer
      emailAddress: this.userDetails.email,
    }

    const loading = await this.loadingController.create({
      message: 'Switching...',
    });
    await loading.present();   
    
    try {
      const response = await this.api.switchProgressCallBackApp(switchPayload).toPromise();
      if (response.success) {
        loading.dismiss();
        const alert = await this.alertCtrl.create({
          mode: 'ios',
          cssClass: 'bill-alert alert-icon',
          message:
            '<img style="margin-top: 2rem;" src="assets/icon/alert/success.svg" alt="warning-icon" /><h2 class="alert-title">Switch process complete</h2><p class="alert-text">We are now validating and processing the information in your details. <br><br><b>*1bill Points for switching will be awarded when the 60 day ‘cooling-off’ period with the new provider has expired.</b></p>',
          buttons: [            
            { 
              cssClass: 'bill-alert alert-icon great-msg',
              text: 'Great!',
              handler: () => {
                this.homeService.triggerFetchHomeData('GetBetterDealsSignupPage::switchProcessCallBack()', true);
                if (this.bill.billPaymentId) {
                  this.router.navigate([ROUTE_BILL_DETAILS], {
                    queryParams: {
                      _source: ROUTE_BILLS_PAGE,
                      billPaymentId: this.bill.billPaymentId,
                    },
                  });
                } else {
                  this.router.navigate([ROUTE_BILL_DETAILS], {
                    queryParams: { _source: ROUTE_BILLS_PAGE, jobId: this.bill.jobId },
                  });
                }
              },
            },
          ],
        });
        await alert.present();
      } else {
        loading.dismiss();
        this.errorAlert();
      }
    } catch (err) {
      loading.dismiss();
      this.errorAlert();
      this.logger.error('switch callback error', err);
    }
  }

  async presentToast(color: 'success' | 'danger' | 'warning', message: string) {
    const toast = await this.toastController.create({
      message,
      duration: 3000,
      color,
      buttons: [
        {
          icon: 'close-circle-outline',
          role: 'cancel',
        },
      ],
    });
    toast.present();
  }

  async errorAlert() {
    const alert = await this.alertCtrl.create({
      mode: 'ios',
      cssClass: 'bill-alert alert-icon',
      message:
        '<img src="assets/icon/alert/warning.svg" alt="warning-icon" /><h2 class="alert-title">Oops!</h2><p class="alert-text">Something went wrong! Please try again later.</p>',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
        },
        {
          text: 'Got it',
          handler: () => {
            this.navCtrl.navigateRoot([ROUTE_BILLS_PAGE]);
          },
        },
      ],
    });
    await alert.present();
  }

  async validateForm() {
    let isValid = true;
    //validate userdetails form
    if (this.userDetailsForm.invalid) {
      this.userDetailsForm.markAllAsTouched();
      isValid = false;
    }

    //Connection
    if (this.fuelType == 'Electricity' || this.fuelType == 'Dual') {
      if (this.hasPowerCurrently == undefined) {
        this.hasPowerCurrentlyError = true;
        isValid = false;
      }
      //connection on
      if (
        this.hasPowerCurrently == true &&
        this.hasPowerCurrentlyRule &&
        this.hasPowerCurrentlyRule?.true?.fields[0] == 'altToElectricity'
      ) {
        if (this.altToElectricity == undefined) {
          this.altToElectricityError = true;
          isValid = false;
        }
        if (
          this.altToElectricity == true &&
          this.altToElectricityRule?.true?.fields[0] == 'electronicCertificate'
        ) {
          if (this.electronicCertificate == undefined) {
            this.electronicCertificateError = true;
            isValid = false;
          }
        }
      }
      //connection off
      if (
        this.hasPowerCurrently == false &&
        this.hasPowerCurrentlyRule &&
        this.hasPowerCurrentlyRule?.false?.fields[0] == 'altToElectricity'
      ) {
        if (this.altToElectricity == undefined) {
          this.altToElectricityError = true;
          isValid = false;
        }
        if (
          this.altToElectricity == true &&
          this.altToElectricityRule?.true?.fields[0] == 'electronicCertificate'
        ) {
          if (this.electronicCertificate == undefined) {
            this.electronicCertificateError = true;
            isValid = false;
          }
        }
      }
      if (
        this.hasPowerCurrently == false &&
        (this.hasPowerCurrentlyRule?.false?.fields ||
          this.hasPowerCurrentlyRule?.false?.message)
      ) {
        if (this.propertyVacantInRule && this.propertyVacant == undefined) {
          this.propertyVacantError = true;
          isValid = false;
        }
        if (
          this.siteHazardNotesInRule &&
          this.product.retailerId != 8 &&
          this.product.retailerId != 7 &&
          this.siteHazardNotes == undefined
        ) {
          this.siteHazardNotesError = true;
          isValid = false;
        }
        if (this.inspectionTimeframeInRule && this.inspectionTimeframe == undefined) {
          this.inspectionTimeframeError = true;
          isValid = false;
        }
      }
    }
    //Solar
    if (!this.isSolar && this.addSolar == undefined && this.fuelType == 'Electricity') {
      this.addSolarError = true;     
      isValid = false;
    }
    //Life Support
    if (
      this.state != 'WA' &&
      this.product.retailerName != 'AGL' &&
      this.isLifeSupport
    ) {
      if (this.lifeSupportFuel == undefined) {
        this.lifeSupportFuelError = true;
        isValid = false;
      }
      if (this.lifeSupportDeviceId == undefined) {
        this.lifeSupportDeviceIdError = true;
        isValid = false;
      }
    }
    //Power Of Choice
    if (this.powerOfChoiceRule && this.powerOfChoice == undefined) {
      this.powerOfChoiceError = true;
      isValid = false;
    }
    //Access Meter
    if (this.clearAccessMeterRule) {
      if (this.product.fuelType == 'Electricity' || this.product.fuelType == 'Dual') {
        if (this.clearAccessElec == undefined) {
          this.clearAccessElecError = true;
          isValid = false;
        }
      }
      if (this.product.fuelType == 'Gas' || this.product.fuelType == 'Dual') {
        if (this.clearAccessGas == undefined) {
          this.clearAccessGasError = true;
          isValid = false;
        }
      }
    }
    //Actual Read
    if (this.actualReadRule && this.actualRead == undefined) {
      this.actualReadError = true;
      isValid = false;
    }
    //Concession
    if (this.concession == undefined) {
      this.concessionError = true;
      isValid = false;
    }
    if (this.concession == true && this.concessionCardForm.invalid && this.product.retailerName != 'EnergyAustralia' && this.product.retailerName != 'Powershop' && this.state !='SA') {
      if(this.state != 'WA' && this.product.retailerName != 'AGL' ){      
        this.concessionCardForm.markAllAsTouched();
        isValid = false;
      }      
    }
    if (
      this.concession == true &&
      this.concessionRule?.true?.fields[0] == 'concessionTCAccepted'
    ) {
      if (!this.concessionAccept) isValid = false;
    }
    //HeatCool Concession
    if (
      this.product.retailerName == 'Tango Energy' &&
      (this.state == 'VIC' || this.state == 'NSW')
    ) {
      if (this.heatCoolConcession == undefined) {
        this.heatCoolConcessionError = true;
        isValid = false;
      }
    }
    //CarbonNeutral
    if (this.product.retailerName == 'AGL' || this.product.retailerName == 'Power Direct') {
      if (this.fuelType == 'Electricity' && this.carbonNeutralOptIn == undefined) {
        this.carbonNeutralOptInError = true;
        isValid = false;
      }
      if (this.fuelType == 'Gas' && this.carbonNeutralOptIn == undefined) {
        this.carbonNeutralOptInError = true;
        isValid = false;
      }
      if (
        this.fuelType == 'Dual' &&
        (this.carbonNeutralOptIn == undefined || this.carbonNeutralOptInValue == undefined)
      ) {
        this.carbonNeutralOptInError = true;
        isValid = false;
      }
    }
    //Secondary Account
    if (this.authorisedPerson == undefined) {
      this.authorisedPersonError = true;
      isValid = false;
    }
    if (
      this.authorisedPerson == true &&
      this.secondaryAccountForm.invalid &&
      this.product.retailerName != 'Simply Energy'
    ) {
      this.secondaryAccountForm.markAllAsTouched();
      isValid = false;
    }
    //billCycle
    if (this.product.retailerName == 'Momentum Energy' && this.state == 'VIC') {
      if (this.billCycle == undefined) {
        this.billCycleError = true;
        isValid = false;
      }
    }
    //marketing
    if (!this.retailSubscriptionExclude && this.marketingConsent == undefined) {
      this.marketingConsentError = true;
      isValid = false;
    }
    //bill postage
    if (this.product.retailerName != 'EnergyAustralia') {
      if (this.billFormat == undefined) {
        this.billFormatError = true;
        isValid = false;
      }
      if (this.billFormat == 'post' && this.billPostTo == undefined) {
        this.billFormatError = true;
        isValid = false;
      }

      if (
        this.billFormat == 'post' &&
        this.billPostTo == 'different_address' &&
        this.customAddress.invalid
      ) {
        this.customAddress.markAllAsTouched();
        isValid = false;
      }
    } else {
      if (this.billFormat == undefined) {
        this.billFormatError = true;
        isValid = false;
      }
    }
    //credit check
    if (this.product.retailerName == 'AGL' || this.product.retailerName == 'Power Direct') {
      if (!this.creditCheckConsent) isValid = false;
    }

    return isValid;
  }
}
